import { createSlice, PayloadAction } from "@reduxjs/toolkit";
export type SearchParamsType = {
  minPrice: number;
  maxPrice: number;
  numOfBedrooms: number;
  numOfBathrooms: number;
  numOfMasterBeds: number;
  numOfSingleBeds: number;
  numOfGuests: number;
  cityId: string[];
  rating: string[];
  entertainment: string[];
  from: string;
  to: string;
};
const initialState: SearchParamsType = {
  minPrice: 1,
  maxPrice: 10000,
  numOfBedrooms: 0,
  numOfBathrooms: 0,
  numOfMasterBeds: 0,
  numOfSingleBeds: 0,
  numOfGuests: 1,
  cityId: [],
  rating: [],
  entertainment: [],
  from: "",
  to: "",
};

const searchParamsSlice = createSlice({
  name: "searchParams",
  initialState,
  reducers: {
    setSearchParams: (state, action) => {
      const newState = { ...state, ...action.payload };
      return newState;
    },

    getAllFromSearchParams: (
      _state,
      action: PayloadAction<Record<string, string | string[]>>
    ) => {
      const result = { ...initialState };

      const arrayKeys = ["cityId", "rating", "entertainment"];

      Object.entries(action.payload).forEach(([key, value]) => {
        if (arrayKeys.includes(key)) {
          (result[key as keyof SearchParamsType] as any) = Array.isArray(value)
            ? value
            : [value];
        } else {
          if (key === "from" || key === "to") {
            (result[key as keyof SearchParamsType] as any) = value;
          } else {
            (result[key as keyof SearchParamsType] as any) = Number(value);
          }
        }
      });

      return result;
    },

    clearSearchParams: () => ({
      ...initialState,
    }),
  },
});

export const { setSearchParams, clearSearchParams, getAllFromSearchParams } =
  searchParamsSlice.actions;
export default searchParamsSlice.reducer;
